(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $547eacfe748ce069$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"7lzrd":"wheel.9a50d8f1.js","2UHmY":"F.6b6d9f7c.png","23bri":"H.861eac15.png","8XmVZ":"C.4155e805.png","9xNlb":"FH.1175a7c9.png","fiuGL":"CF.0bf185a5.png","bt2iu":"CH.e5516591.png","8Xwqf":"CFH.41dd1b2b.png","e946x":"beep.711e2a41.mp3","kRpNi":"tada.a948458b.mp3","jIkJ0":"pinball.264d2f48.mp3","i1vRG":"youshouldnotbehere.22918078.js","haKvs":"wheel.3dd7b58c.js"}'));


var $bgphZ = parcelRequire("bgphZ");

var $3vtib = parcelRequire("3vtib");

var $4Feaf = parcelRequire("4Feaf");
var $33904174ba67424f$require$stringify = $4Feaf.stringify;
const $33904174ba67424f$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $33904174ba67424f$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $33904174ba67424f$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
$3vtib.initialize($33904174ba67424f$var$APP_ID, $33904174ba67424f$var$JAVASCRIPT_KEY);
$3vtib.serverURL = $33904174ba67424f$var$SERVER_URL;
var $33904174ba67424f$var$startC, $33904174ba67424f$var$startF, $33904174ba67424f$var$startHH, $33904174ba67424f$var$startButton, $33904174ba67424f$var$btnFilters, $33904174ba67424f$var$btnCancelFilters, $33904174ba67424f$var$btnConfirmFilters, $33904174ba67424f$var$btnRandomize, $33904174ba67424f$var$btnSelectSpot, $33904174ba67424f$var$btnTryAgain, $33904174ba67424f$var$btnGoBack, $33904174ba67424f$var$startModal, $33904174ba67424f$var$filterModal, $33904174ba67424f$var$resultModal, $33904174ba67424f$var$emptyModal, $33904174ba67424f$var$spotsData, $33904174ba67424f$var$filteredSpotData, $33904174ba67424f$var$randomizedSpotData, $33904174ba67424f$var$attributesData, $33904174ba67424f$var$currentlySelectedSpotIndex, $33904174ba67424f$var$spotCards, $33904174ba67424f$var$ticker, $33904174ba67424f$var$lottiePlayer, $33904174ba67424f$var$btnSnacksYes, $33904174ba67424f$var$btnSnacksNo;
const $33904174ba67424f$var$starveEmojis = [
    "☠️",
    "\uD83E\uDDB4",
    "\uD83E\uDEE0",
    "\uD83E\uDD7A",
    "\uD83E\uDD75",
    "\uD83E\uDD2C",
    "\uD83D\uDE35",
    "\uD83D\uDC80",
    "\uD83E\uDEA6",
    "⚰️"
];
var $ac3b176e64bfeaf1$exports = {};


$ac3b176e64bfeaf1$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("2UHmY");


var $9ea0ca26100502fa$exports = {};


$9ea0ca26100502fa$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("23bri");


var $3743d717a7a00fc4$exports = {};


$3743d717a7a00fc4$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("8XmVZ");


var $45fcbdf53735a2a8$exports = {};


$45fcbdf53735a2a8$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("9xNlb");


var $4f326a963fd41771$exports = {};


$4f326a963fd41771$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("fiuGL");


var $6c38559fabfe4564$exports = {};


$6c38559fabfe4564$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("bt2iu");


var $197039539a22c834$exports = {};


$197039539a22c834$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("8Xwqf");


const $33904174ba67424f$var$defaultImages = [
    new URL($ac3b176e64bfeaf1$exports),
    new URL($9ea0ca26100502fa$exports),
    new URL($3743d717a7a00fc4$exports),
    new URL($45fcbdf53735a2a8$exports),
    new URL($4f326a963fd41771$exports),
    new URL($6c38559fabfe4564$exports),
    new URL($197039539a22c834$exports)
];
const $33904174ba67424f$var$options = {
    coffee: false,
    food: false,
    happyHour: false,
    indoor: false,
    outdoor: false,
    takeout: false,
    large: false,
    snacks: false
};
var $b42839a104075055$exports = {};


$b42839a104075055$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("e946x");


const $33904174ba67424f$var$beep = new Audio(new URL($b42839a104075055$exports));
var $c84e5dcfe516d918$exports = {};


$c84e5dcfe516d918$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("kRpNi");


const $33904174ba67424f$var$tada = new Audio(new URL($c84e5dcfe516d918$exports));
var $50ea5d844a8ab8c4$exports = {};


$50ea5d844a8ab8c4$exports = (parcelRequire("aNJCr")).getBundleURL("7lzrd") + (parcelRequire("iE7OH")).resolve("jIkJ0");


const $33904174ba67424f$var$ping = new Audio(new URL($50ea5d844a8ab8c4$exports));
window.addEventListener("load", ()=>{
    $33904174ba67424f$var$initUI();
    $33904174ba67424f$var$setUIState(false);
    $33904174ba67424f$var$getAttributes().then(()=>{
        $33904174ba67424f$var$getSpots().then(()=>{
            $33904174ba67424f$var$setUIState(true);
        }).catch(function(e) {
            console.log(e);
            $33904174ba67424f$var$handleParseError("Error when fetching Spots", e);
        });
    }).catch(function(e) {
        console.log(e);
        $33904174ba67424f$var$handleParseError("Error when fetching Attributes", e);
    });
});
const $33904174ba67424f$var$setUIState = (enabled)=>{
    if (enabled) {
        $33904174ba67424f$var$startModal.classList.remove("hidden");
        document.getElementById("first-action-bar").classList.remove("hidden");
        document.querySelector(".container").classList.remove("hidden");
        document.querySelector(".loader").classList.add("hidden");
    } else {
        $33904174ba67424f$var$startModal.classList.add("hidden");
        document.getElementById("first-action-bar").classList.add("hidden");
        document.querySelector(".container").classList.add("hidden");
        document.querySelector(".loader").classList.remove("hidden");
    }
};
const $33904174ba67424f$var$initUI = ()=>{
    //startup stuff
    $33904174ba67424f$var$startModal = document.getElementById("startModal");
    $33904174ba67424f$var$startC = document.getElementById("choiceCardCoffee");
    $33904174ba67424f$var$startF = document.getElementById("choiceCardFood");
    $33904174ba67424f$var$startHH = document.getElementById("choiceCardHH");
    $33904174ba67424f$var$startC.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$startC.classList.toggle("selected");
    });
    $33904174ba67424f$var$startF.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$startF.classList.toggle("selected");
    });
    $33904174ba67424f$var$startHH.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$startHH.classList.toggle("selected");
    });
    $33904174ba67424f$var$startButton = document.getElementById("startButton");
    $33904174ba67424f$var$startButton.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        gsap.fromTo($33904174ba67424f$var$startModal, {
            x: 0
        }, {
            x: -window.innerWidth,
            duration: 0.5,
            ease: "power2.out"
        });
        $33904174ba67424f$var$initSpotOptions();
        $33904174ba67424f$var$renderSpots();
    });
    //filter stuff
    $33904174ba67424f$var$filterModal = document.getElementById("filterModal");
    $33904174ba67424f$var$btnFilters = document.getElementById("btn_filters");
    $33904174ba67424f$var$btnCancelFilters = document.querySelector(".filters img");
    $33904174ba67424f$var$btnConfirmFilters = document.getElementById("filter_button");
    $33904174ba67424f$var$btnFilters.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$filterModal.classList.remove("hidden");
        $33904174ba67424f$var$initFilterModal();
    });
    $33904174ba67424f$var$btnCancelFilters.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$filterModal.classList.add("hidden");
        if ($33904174ba67424f$var$filteredSpotData.length < 1) $33904174ba67424f$var$emptyModal.classList.remove("hidden");
    });
    $33904174ba67424f$var$btnConfirmFilters.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$filterModal.classList.add("hidden");
        $33904174ba67424f$var$updateSpotOptions();
        $33904174ba67424f$var$renderSpots();
    });
    $33904174ba67424f$var$btnSnacksYes = document.getElementById("snacks_y");
    $33904174ba67424f$var$btnSnacksYes.addEventListener("click", ()=>{
        $33904174ba67424f$var$btnSnacksYes.classList.toggle("snack-selected");
        $33904174ba67424f$var$btnSnacksNo.classList.toggle("snack-selected");
    });
    $33904174ba67424f$var$btnSnacksNo = document.getElementById("snacks_n");
    $33904174ba67424f$var$btnSnacksNo.addEventListener("click", ()=>{
        $33904174ba67424f$var$btnSnacksYes.classList.toggle("snack-selected");
        $33904174ba67424f$var$btnSnacksNo.classList.toggle("snack-selected");
    });
    //main ui stuff
    $33904174ba67424f$var$spotCards = document.querySelector(".card-wrapper").children;
    $33904174ba67424f$var$btnRandomize = document.getElementById("btn_randomize");
    $33904174ba67424f$var$btnRandomize.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$renderSpots();
    });
    $33904174ba67424f$var$btnSelectSpot = document.getElementById("btn_pick");
    $33904174ba67424f$var$btnSelectSpot.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$pickASpot();
    });
    //results stuff
    $33904174ba67424f$var$resultModal = document.getElementById("resultsModal");
    $33904174ba67424f$var$btnTryAgain = document.getElementById("btn_tryAgain");
    $33904174ba67424f$var$btnTryAgain.addEventListener("click", ()=>{
        $33904174ba67424f$var$beep.play();
        $33904174ba67424f$var$spotCards[$33904174ba67424f$var$currentlySelectedSpotIndex].classList.remove("card-active");
        gsap.fromTo($33904174ba67424f$var$resultModal, {
            x: 0
        }, {
            x: -window.innerWidth,
            duration: 0.75,
            ease: "expo.out(1, 0.5)",
            onComplete: ()=>{
                $33904174ba67424f$var$resultModal.classList.add("hidden");
            }
        });
    });
    $33904174ba67424f$var$lottiePlayer = document.getElementById("lottie");
    //empty stuff
    $33904174ba67424f$var$emptyModal = document.getElementById("emptyModal");
    $33904174ba67424f$var$btnGoBack = document.getElementById("btn_goBack");
    $33904174ba67424f$var$btnGoBack.addEventListener("click", ()=>{
        $33904174ba67424f$var$initFilterModal();
        $33904174ba67424f$var$emptyModal.classList.add("hidden");
        $33904174ba67424f$var$filterModal.classList.remove("hidden");
    });
};
const $33904174ba67424f$var$initSpotOptions = ()=>{
    $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$spotsData;
    if ($33904174ba67424f$var$startC.classList.contains("selected")) $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$filteredSpotData.filter((s)=>{
        return s.get("Category").includes($33904174ba67424f$var$startC.dataset.value);
    });
    if ($33904174ba67424f$var$startF.classList.contains("selected")) $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$filteredSpotData.filter((s)=>{
        return s.get("Category").includes($33904174ba67424f$var$startF.dataset.value);
    });
    if ($33904174ba67424f$var$startHH.classList.contains("selected")) $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$filteredSpotData.filter((s)=>{
        return s.get("Category").includes($33904174ba67424f$var$startHH.dataset.value);
    });
    $33904174ba67424f$var$options.coffee = $33904174ba67424f$var$startC.classList.contains("selected");
    $33904174ba67424f$var$options.food = $33904174ba67424f$var$startF.classList.contains("selected");
    $33904174ba67424f$var$options.happyHour = $33904174ba67424f$var$startHH.classList.contains("selected");
};
const $33904174ba67424f$var$updateSpotOptions = ()=>{
    $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$spotsData;
    [
        ...document.getElementById("filter_cats").options
    ].forEach(function(element) {
        if (element.selected) $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$filteredSpotData.filter((s)=>{
            return s.get("Category").includes(element.value);
        });
        if (element.text.startsWith("F")) $33904174ba67424f$var$options.food = element.selected;
        else if (element.text.startsWith("C")) $33904174ba67424f$var$options.coffee = element.selected;
        else $33904174ba67424f$var$options.happyHour = element.selected;
    });
    if ($33904174ba67424f$var$btnSnacksYes.classList.contains("snack-selected")) $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$filteredSpotData.filter((s)=>{
        return s.get("HasSnacks") == true;
    });
    $33904174ba67424f$var$options.snacks = $33904174ba67424f$var$btnSnacksYes.classList.contains("snack-selected");
    [
        ...document.getElementById("filter_sets").options
    ].forEach(function(element) {
        if (element.selected) $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$filteredSpotData.filter((s)=>{
            return s.get("Setting").includes(element.value);
        });
        if (element.text.startsWith("I")) $33904174ba67424f$var$options.indoor = element.selected;
        else if (element.text.startsWith("O")) $33904174ba67424f$var$options.outdoor = element.selected;
        else $33904174ba67424f$var$options.takeout = element.selected;
    });
    if (document.getElementById("large_y").selected) $33904174ba67424f$var$filteredSpotData = $33904174ba67424f$var$filteredSpotData.filter((s)=>{
        return s.get("LargeParties") == true;
    });
    $33904174ba67424f$var$options.large = document.getElementById("large_y").selected;
};
const $33904174ba67424f$var$renderSpots = ()=>{
    if ($33904174ba67424f$var$filteredSpotData.length < 1) {
        $33904174ba67424f$var$emptyModal.classList.remove("hidden");
        return;
    }
    var used = [];
    $33904174ba67424f$var$randomizedSpotData = [];
    if ($33904174ba67424f$var$filteredSpotData.length < 12) for(var i = 0; i < 12 - $33904174ba67424f$var$filteredSpotData.length; i++)$33904174ba67424f$var$randomizedSpotData.push({
        name: `Starve ${$33904174ba67424f$var$starveEmojis[$33904174ba67424f$var$randomNumber(0, $33904174ba67424f$var$starveEmojis.length)]}`,
        id: "starve"
    });
    while($33904174ba67424f$var$randomizedSpotData.length < 12){
        var n = $33904174ba67424f$var$randomNumber(0, $33904174ba67424f$var$filteredSpotData.length);
        while(used.includes(n))n = $33904174ba67424f$var$randomNumber(0, $33904174ba67424f$var$filteredSpotData.length);
        used.push(n);
        $33904174ba67424f$var$randomizedSpotData.push({
            name: $33904174ba67424f$var$filteredSpotData[n].get("Name"),
            id: $33904174ba67424f$var$filteredSpotData[n].id
        });
    }
    used = [];
    while(used.length < 12){
        var n = $33904174ba67424f$var$randomNumber(0, $33904174ba67424f$var$randomizedSpotData.length);
        while(used.includes(n))n = $33904174ba67424f$var$randomNumber(0, $33904174ba67424f$var$randomizedSpotData.length);
        used.push(n);
        $33904174ba67424f$var$spotCards[used.length - 1].dataset.id = $33904174ba67424f$var$randomizedSpotData[n].id;
        $33904174ba67424f$var$spotCards[used.length - 1].innerHTML = $33904174ba67424f$var$randomizedSpotData[n].name;
    }
};
const $33904174ba67424f$var$initFilterModal = ()=>{
    [
        ...document.getElementById("filter_cats").options
    ].forEach(function(element) {
        if (element.text.startsWith("F")) element.selected = $33904174ba67424f$var$options.food;
        else if (element.text.startsWith("C")) element.selected = $33904174ba67424f$var$options.coffee;
        else element.selected = $33904174ba67424f$var$options.happyHour;
    });
    [
        ...document.getElementById("filter_sets").options
    ].forEach(function(element) {
        if (element.text.startsWith("I")) element.selected = $33904174ba67424f$var$options.indoor;
        else if (element.text.startsWith("O")) element.selected = $33904174ba67424f$var$options.outdoor;
        else element.selected = $33904174ba67424f$var$options.takeout;
    });
    document.getElementById("large_y").selected = $33904174ba67424f$var$options.large;
    document.getElementById("large_n").selected = !$33904174ba67424f$var$options.large;
    if ($33904174ba67424f$var$options.snacks) {
        $33904174ba67424f$var$btnSnacksYes.classList.add("snacks-selected");
        $33904174ba67424f$var$btnSnacksNo.classList.remove("snacks-selected");
    } else {
        $33904174ba67424f$var$btnSnacksYes.classList.remove("snacks-selected");
        $33904174ba67424f$var$btnSnacksNo.classList.add("snacks-selected");
    }
};
const $33904174ba67424f$var$setRandomSpot = ()=>{
    if ($33904174ba67424f$var$currentlySelectedSpotIndex) $33904174ba67424f$var$spotCards[$33904174ba67424f$var$currentlySelectedSpotIndex].classList.remove("card-active");
    var n = $33904174ba67424f$var$randomNumber(1, $33904174ba67424f$var$randomizedSpotData.length);
    while(n == $33904174ba67424f$var$currentlySelectedSpotIndex)n = $33904174ba67424f$var$randomNumber(1, $33904174ba67424f$var$randomizedSpotData.length);
    $33904174ba67424f$var$currentlySelectedSpotIndex = n;
    $33904174ba67424f$var$spotCards[$33904174ba67424f$var$currentlySelectedSpotIndex].classList.add("card-active");
};
const $33904174ba67424f$var$startSelectingSpots = (stop)=>{
    $33904174ba67424f$var$ping.play();
    $33904174ba67424f$var$setRandomSpot();
    if (stop) {
        while($33904174ba67424f$var$spotCards[$33904174ba67424f$var$currentlySelectedSpotIndex].dataset.id == "starve")$33904174ba67424f$var$setRandomSpot();
        window.setTimeout(()=>{
            $33904174ba67424f$var$handleSuccess();
        }, 1000);
    }
};
//picker animation
const $33904174ba67424f$var$pickASpot = ()=>{
    $33904174ba67424f$var$ticker = 0;
    $33904174ba67424f$var$startSelectingSpots(false);
    gsap.to(".container", {
        opacity: 1,
        duration: 5,
        ease: "power2.out",
        onUpdate: ()=>{
            $33904174ba67424f$var$ticker++;
            if ($33904174ba67424f$var$ticker % 10 == 0) $33904174ba67424f$var$startSelectingSpots(false);
        },
        onComplete: ()=>{
            $33904174ba67424f$var$startSelectingSpots(true);
        }
    });
};
const $33904174ba67424f$var$handleSuccess = ()=>{
    const spot = $33904174ba67424f$var$spotsData.filter((s)=>{
        return s.id == $33904174ba67424f$var$spotCards[$33904174ba67424f$var$currentlySelectedSpotIndex].dataset.id;
    })[0];
    const spotOptions = spot.get("Category");
    $33904174ba67424f$var$resultModal.classList.remove("hidden");
    gsap.fromTo($33904174ba67424f$var$resultModal, {
        x: window.innerWidth
    }, {
        x: 0,
        duration: 0.5,
        ease: "expo.out(1, 0.5)"
    });
    document.getElementById("winner_name").innerHTML = spot.get("Name");
    const item = document.getElementById("winner_img");
    if (!spot.get("Image")) {
        if (spotOptions.includes($33904174ba67424f$var$startC.dataset.value) && spotOptions.includes($33904174ba67424f$var$startF.dataset.value) && spotOptions.includes($33904174ba67424f$var$startHH.dataset.value)) input.src = $33904174ba67424f$var$defaultImages[6];
        else if (spotOptions.includes($33904174ba67424f$var$startC.dataset.value) && spotOptions.includes($33904174ba67424f$var$startF.dataset.value)) item.src = $33904174ba67424f$var$defaultImages[4];
        else if (spotOptions.includes($33904174ba67424f$var$startC.dataset.value) && spotOptions.includes($33904174ba67424f$var$startHH.dataset.value)) item.src = $33904174ba67424f$var$defaultImages[5];
        else if (spotOptions.includes($33904174ba67424f$var$startF.dataset.value) && spotOptions.includes($33904174ba67424f$var$startHH.dataset.value)) item.src = $33904174ba67424f$var$defaultImages[3];
        else if (spotOptions.includes($33904174ba67424f$var$startF.dataset.value)) item.src = $33904174ba67424f$var$defaultImages[0];
        else if (spotOptions.includes($33904174ba67424f$var$startC.dataset.value)) item.src = $33904174ba67424f$var$defaultImages[2];
        else item.src = $33904174ba67424f$var$defaultImages[1];
    } else item.src = spot.get("Image").url();
    if (spot.get("Quote")) {
        document.querySelector(".quote-wrapper").classList.remove("hidden");
        document.getElementById("winner_quote").innerHTML = spot.get("Quote").length > 0 ? `"${spot.get("Quote").replace(new RegExp('"', "g"), "")}"` : "";
        if (spot.get("Quotee")) document.getElementById("winner_quotee").innerHTML = spot.get("Quotee");
    } else document.querySelector(".quote-wrapper").classList.add("hidden");
    document.getElementById("winner_address").innerHTML = spot.get("Address");
    document.getElementById("winner_address").href = spot.get("MapUrl");
    if (spot.get("WebsiteUrl")) {
        const menu = document.getElementById("winner_menu");
        menu.classList.remove("hidden");
        menu.href = spot.get("WebsiteUrl");
        menu.innerHTML = spot.get("WebsiteUrl").replace("https://www.", "").replace(".com/", ".com");
    } else document.getElementById("winner_menu").classList.add("hidden");
    $33904174ba67424f$var$tada.play();
    $33904174ba67424f$var$lottiePlayer.load((0, (/*@__PURE__*/$parcel$interopDefault($bgphZ))));
};
async function $33904174ba67424f$var$getSpots() {
    const query = new $3vtib.Query("WheelSpot");
    query.ascending("Name");
    try {
        $33904174ba67424f$var$spotsData = await query.find();
    } catch (error) {
        throw error;
    }
}
async function $33904174ba67424f$var$getAttributes() {
    const query = new $3vtib.Query("WheelSpotAttribute");
    try {
        $33904174ba67424f$var$attributesData = await query.find();
        var input1 = document.getElementById("filter_cats");
        const categories = $33904174ba67424f$var$attributesData.filter((a)=>a.get("Type") == "Category");
        categories.forEach((c)=>{
            const o = document.createElement("option");
            o.text = c.get("Value");
            o.value = c.id;
            input1.add(o);
            if (c.get("Value") === "Coffee") $33904174ba67424f$var$startC.dataset.value = c.id;
            else if (c.get("Value") === "Food") $33904174ba67424f$var$startF.dataset.value = c.id;
            else $33904174ba67424f$var$startHH.dataset.value = c.id;
        });
        [
            ...input1.options
        ].forEach(function(element) {
            element.addEventListener("mousedown", function(e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                return false;
            }, false);
        });
        input1 = document.getElementById("filter_sets");
        const settings = $33904174ba67424f$var$attributesData.filter((a)=>a.get("Type") == "Setting");
        settings.forEach((c)=>{
            const o = document.createElement("option");
            o.text = c.get("Value");
            o.value = c.id;
            input1.add(o);
        });
        [
            ...input1.options
        ].forEach(function(element) {
            element.addEventListener("mousedown", function(e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                return false;
            }, false);
        });
    } catch (error) {
        throw error;
    }
}
function $33904174ba67424f$var$randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
}
function $33904174ba67424f$var$handleParseError(msg, err) {
    switch(err.code){
        case $3vtib.Error.INVALID_SESSION_TOKEN:
            $3vtib.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}

})();
//# sourceMappingURL=wheel.9a50d8f1.js.map
